import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components/macro';

const LoadingSpinner = styled.div`
  animation: spin 600ms infinite linear;
  border: 3px solid ${themeGet('olist.color.primary.base')};
  border-radius: ${themeGet('olist.borderRadius.circle')};
  border-top-color: ${themeGet('olist.color.neutral.softest')};
  height: 18px;
  left: 50%;
  margin: auto;
  top: 50%;
  width: 18px;
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export default LoadingSpinner;
